import { cn } from '@/design-system/lib/cn';

export type ProgressBarProps = {
  /** 0 a 100. */
  value: number;
  /** Nome do que é medido; sem ele a barra é decorativa (o número aparece ao lado). */
  label?: string;
  /** Classe de cor da barra (`bg-primary`, `bg-status-complete-bar`). */
  barClassName?: string;
  /** Cor da barra quando é dado (cor do ministério). */
  color?: string;
  size?: 'xs' | 'sm' | 'md';
  className?: string;
};

/** Trilho arredondado com a barra animada (largura em 0,3s). */
export function ProgressBar({
  value,
  label,
  barClassName = 'bg-primary',
  color,
  size = 'sm',
  className,
}: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, value));

  return (
    <span
      role={label ? 'progressbar' : undefined}
      aria-label={label}
      aria-valuenow={label ? Math.round(pct) : undefined}
      aria-valuemin={label ? 0 : undefined}
      aria-valuemax={label ? 100 : undefined}
      aria-hidden={label ? undefined : true}
      className={cn(
        'block overflow-hidden rounded-pill bg-line-divider',
        size === 'md' ? 'h-2' : 'h-1.5',
        className
      )}
    >
      <span
        className={cn('block h-full rounded-pill transition-[width] duration-300', !color && barClassName)}
        style={{ width: `${pct}%`, ...(color ? { backgroundColor: color } : {}) }}
      />
    </span>
  );
}
